module.exports = __webpack_public_path__ + "static/media/no-commerce.df9f6114.svg";